import type { CohesiveAPIClient } from "@cohesive/api-client";
import { createContext, useContext } from "react";

export interface ElementsContextValue {
  /** The configured API client with optional org/user impersonation */
  client: CohesiveAPIClient;
  /** The organization ID if impersonating */
  organizationId?: string;
  /** The user ID if impersonating */
  userId?: string;
}

export const ElementsContext = createContext<ElementsContextValue | null>(null);

/**
 * Hook to access the Elements context.
 * Must be used within an ElementsProvider.
 */
export function useElementsContext(): ElementsContextValue {
  const context = useContext(ElementsContext);
  if (!context) {
    throw new Error(
      "useElementsContext must be used within an ElementsProvider",
    );
  }
  return context;
}

/**
 * Hook to access the configured API client from Elements context.
 * This is a convenience wrapper around useElementsContext.
 */
export function useElementsApiClient(): CohesiveAPIClient {
  const { client } = useElementsContext();
  return client;
}
